(function () {
    'use strict';

    angular
        .module('app')
        .factory('publishWaveService', publishWaveService);

    publishWaveService.$inject = ['$http', '$q'];

    function publishWaveService($http, $q) {
        var service = {
            enabled: null,
            checkServerConfiguration: checkServerConfiguration,
     };
        return service;

        var showDialogDeffered;

        // Check if PW applies to the given records
        function checkServerConfiguration(items, commandNumber) {
            var deferred = $q.defer();
            var selectionItems = [];

            angular.forEach(items, function (item) {
                if (item.selectionItem)
                    selectionItems.push(item.selectionItem);
                else
                    selectionItems.push(item);
            });

            // Is it enabled?
            isEnabled().then(function (enabled) {
                if (enabled) {
                    // Check each record
                    checkRecords(selectionItems, commandNumber).then(function (publishWaveData) {
                        deferred.resolve(publishWaveData);
                    }, function (error) {
                        deferred.reject(error);
                    });
                }
                else {
                    deferred.resolve({});
                }
            });
            return deferred.promise;
        }

        //checks if required fields plugin is enabled
        function isEnabled() {
            var deferred = $q.defer();

            //if enabled has never been set, check with the server
            if (service.enabled === null) {
                $http.get('../synergis.webapi/api/PublishWave/isenabled').then(function (resp) {
                    service.enabled = resp.data;
                    deferred.resolve(service.enabled);
                }, function (error) {
                    deferred.resolve(false);
                });
            }
            else {
                deferred.resolve(service.enabled);
            }

            return deferred.promise;
        }

        // Sends a list of selection items to the server to verify if PW is configured and running
        function checkRecords(selectionItems, commandNumber) {
            var deferred = $q.defer();

            $http({
                url: '../Synergis.WebApi/api/PublishWave/checkrecords?commandNumber='.concat(commandNumber),
                method: 'POST',
                data: JSON.stringify(selectionItems),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject();
            });
            return deferred.promise;
        }
    }
})();